import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecabs() {



  const cardData =
  {
    keyword: 'Pune to Indore Cabs',
    heading: 'Sai Trupti Cabs: Pune to Indore Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Indore cab services, designed to make your out-station journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your long-drive comfort. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Indore. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Indore convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Indore with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "Rajwada Palace is the iconic symbol of Indore’s royal past, built by the Holkar dynasty over two centuries ago. Located in the bustling heart of the city, this seven-storey architectural marvel blends Maratha, Mughal, and French styles. The massive wooden gates open to courtyards, arched balconies, and ornate jharokhas that whisper stories of regal grandeur. At night, the illuminated façade glows majestically, reflecting Indore’s proud heritage. Visitors can explore nearby markets for handicrafts and street snacks. Rajwada isn’t just a monument — it’s a living chronicle of Indore’s art, culture, and timeless elegance."
  },
  {
    "title": "Lal Bagh Palace",
    "description": "Lal Bagh Palace, once the grand residence of the Holkar rulers, stands on the banks of the Khan River as a masterpiece of European opulence. Built between 1886 and 1921, the palace features Italian marble floors, Belgium-made glass windows, and lush rose gardens. The grand ballroom with its ornate ceiling still echoes with classical music from royal gatherings. Visitors are often captivated by its decorative gates modeled after Buckingham Palace. Today, it serves as a museum preserving Indore’s regal legacy, allowing travelers to step back into an era of splendor and sophistication."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "By day, Sarafa Bazaar is a jewelry market glimmering with gold and gemstones; by night, it transforms into Indore’s most famous street-food haven. As the sun sets, hundreds of food stalls emerge, serving delicacies like bhutte ka kees, garadu, sabudana khichdi, and the legendary joshi dahi bada. The air fills with the aroma of spices, laughter, and sizzling flavors. Tourists and locals alike wander through narrow lanes indulging in late-night feasts under twinkling lights. Sarafa Bazaar is a sensory explosion — a place where Indore’s culinary soul shines brightest."
  },
  {
    "title": "Khajrana Ganesh Temple",
    "description": "Khajrana Ganesh Temple is one of Indore’s most revered spiritual landmarks, originally built by Queen Ahilyabai Holkar in the 18th century. Dedicated to Lord Ganesha, the temple attracts thousands of devotees who believe that wishes made here come true. The idol of Lord Ganesha, adorned with gold ornaments and flowers, radiates positivity and divine energy. The temple complex also includes smaller shrines dedicated to other deities, creating a deeply spiritual environment. Its peaceful ambiance, especially during morning aarti, fills the heart with serenity and faith. For Indore’s residents, Khajrana isn’t just a temple — it’s a source of strength and devotion."
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "The Central Museum, also known as Indore Museum, showcases the rich cultural heritage and artistic brilliance of Madhya Pradesh. Its galleries display ancient sculptures, medieval coins, tribal art, and intricately carved idols from the Parmar and Gupta periods. History enthusiasts are particularly drawn to the 11th-century sandstone figures and weapons of the Holkar era. The museum’s peaceful surroundings and educational exhibits make it an ideal stop for families and students. Every artifact tells a story — together they reveal how Indore evolved from a small Maratha settlement into a cultural capital."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "Located about 35 kilometers from Indore, Patalpani Waterfall cascades from a height of 300 feet amidst dense forests and rocky cliffs. The name ‘Patalpani’ comes from local legends suggesting that the water plunges deep into the underworld (patal). During monsoon, the waterfall roars with full force, enveloped in mist and rainbows. Visitors love picnicking, trekking, and photographing the dramatic scenery. The nearby railway bridge adds cinematic charm to this natural wonder. It’s a refreshing getaway for those seeking adventure and serenity close to the city’s bustle."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Ralamandal Wildlife Sanctuary is Indore’s green oasis, offering a perfect blend of wilderness and tranquility. Spread over rolling hills, it houses deer, blue bulls, leopards, and numerous bird species. The sanctuary also features an old hunting lodge built by the Holkar rulers, now serving as a forest rest house. Trekking trails lead through teak forests and hilltops that open to panoramic views of Indore’s skyline. Early mornings here are filled with birdsong and cool breeze, making it an ideal spot for nature lovers, photographers, and families seeking a peaceful retreat."
  },
  {
    "title": "Chhappan Dukan",
    "description": "Chhappan Dukan, meaning '56 shops', is Indore’s most iconic food street where every shop is dedicated to taste and tradition. From poha-jalebi breakfasts to chaat, pani puri, and milkshakes, this vibrant lane is always buzzing with hungry visitors. Clean, organized, and lively, it offers a modern twist to Indore’s legendary street-food culture. The evenings come alive with lights, laughter, and the irresistible smell of spices. Whether you’re craving traditional snacks or fusion treats, Chhappan Dukan guarantees an unforgettable culinary experience that defines Indore’s foodie heart."
  },
  {
    "title": "Annapurna Temple",
    "description": "Modeled after the Meenakshi Temple of Madurai, Annapurna Temple is one of Indore’s most architecturally stunning religious sites. Dedicated to the goddess of nourishment, Annapurna Devi, the temple’s ornate gates are adorned with elephants and intricate carvings. The four-towered façade, beautiful sculptures, and serene prayer halls create a sacred atmosphere for devotees. The temple also houses shrines for Hanuman, Shiva, and Kalabhairav. Visiting Annapurna Temple offers both peace and aesthetic delight — a must-see for anyone exploring Indore’s cultural and spiritual landscape."
  },
  {
    "title": "Janapav Hill",
    "description": "Janapav Hill, located about 45 kilometers from Indore, is the highest point in the Malwa region and the legendary birthplace of Parashurama, an incarnation of Lord Vishnu. Surrounded by dense forests and cool breezes, it offers trekking trails and mesmerizing sunset views. The hilltop temple dedicated to Parashurama attracts pilgrims year-round. During the monsoon, the entire hill turns lush green with clouds drifting at eye level. Janapav combines mythology, adventure, and nature in one unforgettable destination — a perfect weekend getaway from Indore’s busy life."
  }
],



"services": [
  {
    "name": "Pune to Indore Cabs",
    "description": "Book cabs from Pune to Indore for a comfortable and long-distance journey. Offers AC/non-AC options, professional drivers, luggage assistance, and flexible schedules. Ideal for families, corporate travelers, and tourists."
  },
  {
    "name": "Pune to Indore Taxi Service",
    "description": "Reliable taxi service from Pune to Indore with well-maintained vehicles, punctual pickups, AC/non-AC options, professional chauffeurs, and luggage support. Perfect for safe and hassle-free outstation travel."
  },
  {
    "name": "Pune to Indore Car Hire",
    "description": "Hire a car from Pune to Indore with Sedans, SUVs, and premium vehicles. Offers AC/non-AC options, professional drivers, ample luggage space, and flexible pickup/drop schedules for convenient long-distance trips."
  },
  {
    "name": "Pune to Indore AC Cab",
    "description": "Travel comfortably in AC cabs from Pune to Indore with professional drivers, luggage assistance, flexible pickup/drop points, and well-maintained vehicles. Ideal for families, groups, and business travelers."
  },
  {
    "name": "Pune to Indore Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune to Indore with reliable vehicles, professional drivers, luggage support, and flexible schedules. Perfect for economical travel without compromising safety and comfort."
  },
  {
    "name": "Pune to Indore Innova Cab",
    "description": "Spacious Innova cab service from Pune to Indore with AC/non-AC options, professional drivers, luggage support, and flexible schedules. Ideal for families and groups traveling long distances comfortably."
  },
  {
    "name": "Pune to Indore Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Indore offering AC/non-AC options, professional chauffeurs, luggage support, and ample seating for small families or groups seeking a smooth journey."
  },
  {
    "name": "Luxury Cab Pune to Indore",
    "description": "Premium luxury cab service from Pune to Indore with AC comfort, elegant interiors, professional drivers, luggage assistance, and timely pickups. Perfect for VIP travel, special occasions, and corporate clients."
  },
  {
    "name": "Affordable Pune to Indore Cab",
    "description": "Economical cab service from Pune to Indore offering AC/non-AC options, professional drivers, luggage support, flexible schedules, and transparent fares. Ideal for budget-conscious travelers seeking comfort and reliability."
  },
  {
    "name": "Pune to Indore Outstation Cab",
    "description": "Outstation cab service from Pune to Indore with AC/non-AC options, professional drivers, luggage support, flexible schedules, and online booking for hassle-free long-distance travel."
  },
  {
    "name": "Pune to Indore One Way Cab",
    "description": "Convenient one-way cab service from Pune to Indore with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop points for economical and comfortable travel."
  },
  {
    "name": "Pune to Indore Drop Cab",
    "description": "Safe and punctual drop cab service from Pune to Indore with AC/non-AC vehicles, professional drivers, luggage support, and flexible scheduling for stress-free journeys."
  },
  {
    "name": "Pune to Indore Corporate Cab",
    "description": "Corporate cab service from Pune to Indore with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and reliable service for business trips and corporate outings."
  },
  {
    "name": "Pune to Indore Wedding Cab",
    "description": "Elegant wedding cab service from Pune to Indore with luxury vehicles, AC comfort, professional chauffeurs, luggage assistance, and timely pickups for weddings, family events, and special occasions."
  },
  {
    "name": "Pune to Indore Online Booking",
    "description": "Book your Pune to Indore cab online instantly with AC/non-AC options, professional drivers, flexible pickup/drop points, secure payments, and transparent fares for convenient and hassle-free travel."
  }
],
"tableData": [
  ["Pune to Indore Cabs", "Pune to Indore Taxi Service"],
  ["Pune to Indore Car Hire", "Pune to Indore AC Cab"],
  ["Pune to Indore Non AC Cab", "Pune to Indore Innova Cab"],
  ["Pune to Indore Ertiga Cab", "Luxury Cab Pune to Indore"],
  ["Affordable Pune to Indore Cab", "Pune to Indore Outstation Cab"],
  ["Pune to Indore One Way Cab", "Pune to Indore Drop Cab"],
  ["Pune to Indore Corporate Cab", "Pune to Indore Wedding Cab"],
  ["Pune to Indore Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Indore Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Indore — ideal for long-distance travel, business trips, family visits, or leisure journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Indore cabs, starting at affordable rates depending on vehicle type — with no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Pune–Indore route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Indore route, ensuring a safe, smooth, and timely long-distance journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at any location in Indore, including hotels, railway stations, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for long-distance travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Indore cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]



























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Indore cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Indore cab services for one way, round trips, and group travel.',
  },
  {
    question: 'How can I book a Pune to Indore cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Indore cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking.',
  },
  {
    question: 'What types of cabs are available from Pune to Indore?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Indore trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Indore for family or corporate travel?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and corporate travel between Pune and Indore.',
  },
  {
    question: 'Is the Pune to Indore cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune to Indore to fit your travel schedule.',
  },
  {
    question: 'What are the Pune to Indore cab fares?',
    answer: 'Our cab fares start from approximately ₹6,000 for sedans and ₹7,500–₹9,000 for SUVs and premium vehicles, depending on the vehicle type and number of passengers.',
  },
  {
    question: 'What payment options are accepted for Pune to Indore cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free booking.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Indore cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Pune to Indore cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Indore cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Sharma',
    feedback: 'I booked a Pune to Indore cab with Sai Trupti Cabs. The journey was smooth and the driver was professional and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Verma',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Indore trip. Comfortable car, timely pickup, and hassle-free ride.',
    rating: 5,
  },
];





















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-to-indore-cabs.jpg",
  "description": "Book cabs from Pune to Indore for corporate trips, weddings, or outstation travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-indore-cabs"
  }
};









  return (
    <div>
      <Helmet>
  <title>Pune to Indore Cabs | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book cabs from Pune to Indore for corporate trips, weddings, or outstation travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Indore Cabs, Pune to Indore Taxi Service, Pune to Indore Car Hire, Pune to Indore AC Cab, Pune to Indore Non AC Cab, Pune to Indore Innova Cab, Pune to Indore Ertiga Cab, Luxury Cab Pune to Indore, Affordable Pune to Indore Cab, Pune to Indore Outstation Cab, Pune to Indore One Way Cab, Pune to Indore Drop Cab, Pune to Indore Corporate Cab, Pune to Indore Wedding Cab, Pune to Indore Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoindorecabs;